export default __webpack_public_path__ + "static/media/ejemplo.ce5454fd.jpg";